export const permissionsData = {
    actions: {
        addMetadata: "addMetadata",
        assignToParent: "assignToParent",
        create: "create",
        delete: "delete",
        deleteMetadata: "deleteMetadata",
        disable: "disable",
        edit: "edit",
        editDataSourceCategory: "editDataSourceCategory",
        editMetadata: "editMetadata",
        editPassword: "editPassword",
        enable: "enable",
        filter: "filter",
        manualEntry: "manualEntry",
        manualMatching: "manualMatching",
        manualSync: "manualSync",
        reconcile: "reconcile",
        revertVersionLog: "revertVersionLog",
        search: "search",
        unreconcile: "unreconcile",
        upload: "upload",
        view: "view",
    } as const,
    data: {
        UNKNOWN: {},
        admin: {
            ACCOUNT: {
                assignToParent: true,
                create: true,
                delete: true,
                disable: true,
                edit: true,
                enable: true,
                filter: true,
                search: true,
                view: true,
            },
            DATA_SOURCE: {
                create: true,
                delete: true,
                edit: true,
                filter: true,
                manualSync: true,
                search: true,
                upload: true,
                view: true,
            },
            LEDGER: { view: true },
            ORGANIZATION: {
                create: false,
                edit: false,
                filter: false,
                search: false,
                view: true,
            },
            PROFILE: {
                edit: true,
                editPassword: true,
                view: true,
            },
            RECONCILIATION: {
                create: true,
                delete: true,
                edit: true,
                filter: true,
                reconcile: true,
                search: true,
                unreconcile: true,
                view: true,
            },
            RECONCILIATION_AUDIT_LOG_MATCHING_TRANSACTION: {
                filter: true,
                search: true,
                view: true,
            },
            TRANSACTION: {
                addMetadata: true,
                create: true,
                deleteMetadata: true,
                editMetadata: true,
                filter: true,
                manualEntry: true,
                manualMatching: true,
                revertVersionLog: true,
                search: true,
                view: true,
            },
            USER: {
                create: true,
                delete: true,
                edit: true,
                editPassword: true,
                view: true,
            },
        },
        moderator: {
            ACCOUNT: {
                assignToParent: false,
                create: false,
                delete: false,
                disable: false,
                edit: false,
                enable: false,
                filter: true,
                search: true,
                view: true,
            },
            DATA_SOURCE: {
                create: false,
                delete: false,
                edit: false,
                filter: true,
                manualSync: true,
                search: true,
                upload: true,
                view: true,
            },
            LEDGER: { view: false },
            ORGANIZATION: {
                create: false,
                edit: false,
                filter: false,
                search: false,
                view: false,
            },
            PROFILE: {
                edit: false,
                editPassword: false,
                view: false,
            },
            RECONCILIATION: {
                create: true,
                delete: false,
                edit: false,
                filter: true,
                reconcile: true,
                search: true,
                unreconcile: true,
                view: true,
            },
            RECONCILIATION_AUDIT_LOG_MATCHING_TRANSACTION: {
                filter: true,
                search: true,
                view: true,
            },
            TRANSACTION: {
                addMetadata: true,
                create: true,
                deleteMetadata: true,
                editMetadata: true,
                filter: true,
                manualEntry: true,
                manualMatching: true,
                revertVersionLog: true,
                search: true,
                view: true,
            },
            USER: {
                create: false,
                delete: false,
                edit: false,
                editPassword: false,
                view: false,
            },
        },
        superAdmin: {
            ACCOUNT: {
                assignToParent: true,
                create: true,
                delete: true,
                disable: true,
                edit: true,
                enable: true,
                filter: true,
                search: true,
                view: true,
            },
            ADMIN_DATA_SOURCE: {
                editDataSourceCategory: true,
                search: true,
                view: true,
            },
            DATA_SOURCE: {
                create: true,
                delete: true,
                edit: true,
                filter: true,
                manualSync: true,
                search: true,
                upload: true,
                view: true,
            },
            LEDGER: { view: true },
            ORGANIZATION: {
                create: true,
                edit: true,
                filter: true,
                search: true,
                view: true,
            },
            PROFILE: {
                edit: true,
                editPassword: true,
                view: true,
            },
            RECONCILIATION: {
                create: true,
                delete: true,
                edit: true,
                filter: true,
                reconcile: true,
                search: true,
                unreconcile: true,
                view: true,
            },
            RECONCILIATION_AUDIT_LOG_MATCHING_TRANSACTION: {
                filter: true,
                search: true,
                view: true,
            },
            TRANSACTION: {
                addMetadata: true,
                create: true,
                deleteMetadata: true,
                editMetadata: true,
                filter: true,
                manualEntry: true,
                manualMatching: true,
                revertVersionLog: true,
                search: true,
                view: true,
            },
            USER: {
                create: true,
                delete: true,
                edit: true,
                editPassword: true,
                view: true,
            },
        },
        viewer: {
            ACCOUNT: {
                assignToParent: false,
                create: false,
                delete: false,
                disable: false,
                edit: false,
                enable: false,
                filter: true,
                search: true,
                view: true,
            },
            DATA_SOURCE: {
                create: false,
                delete: false,
                edit: false,
                filter: true,
                manualSync: false,
                search: true,
                upload: false,
                view: true,
            },
            LEDGER: { view: false },
            ORGANIZATION: {
                create: false,
                edit: false,
                filter: false,
                search: false,
                view: false,
            },
            PROFILE: {
                edit: false,
                editPassword: false,
                view: false,
            },
            RECONCILIATION: {
                create: false,
                delete: false,
                edit: false,
                filter: true,
                reconcile: false,
                search: true,
                unreconcile: false,
                view: true,
            },
            TRANSACTION: {
                addMetadata: false,
                create: false,
                deleteMetadata: false,
                editMetadata: false,
                filter: true,
                manualEntry: false,
                manualMatching: false,
                revertVersionLog: false,
                search: true,
                view: true,
            },
            USER: {
                create: false,
                delete: false,
                edit: false,
                editPassword: false,
                view: false,
            },
        },
    },
};
